import debug from 'debug'
import { QRCodeSVG } from 'qrcode.react'
import React from 'react'
import { useSelector } from 'react-redux'
import { ROUTE_ITINERARY_COMPUTING_BY_MODE } from '../../../routes'
import { selectCurrentMode } from '../../../store/itinerary/itinerary.selectors'
import { MODAL_IDS } from '../../../store/ui/ui.constants'
import { withOnlyGE } from '../../Device'
import Modal from '../../genericComponents/Modal'
import ClosePopinButton from '../../genericComponents/ClosePopinButton'
import france from '../../genericComponents/assets/france.svg'
import mappyLogoOutline from '../../genericComponents/assets/mappy-logo-outline.svg'
import signs from '../../genericComponents/assets/signs.svg'
import { PARAM_REDIRECT, REDIRECT_QRCODE } from '../../router/queryParameters.constants'
import { generateDomainFullRoute } from '../../router/route.utils'
import SVGIcon from '../../svg/SVGIcon'
import useModal from '../../ui/useModal'
import useEventCallback from '../../utils/useEventCallback'
import { selectArrivalStep, selectDepartureStep } from '../steps/steps.selectors'
import s from './ShareItineraryPopin.less'

const d = debug('mappy:share')

const ShareItineraryPopin = () => {
  const mode = useSelector(selectCurrentMode)
  const from = useSelector(selectDepartureStep)?.label
  const to = useSelector(selectArrivalStep)?.label

  const { isModalDisplayed, hideModal } = useModal(MODAL_IDS.SHARE_ITINERARY_POPIN)
  const onPopinClose = useEventCallback(hideModal)

  if (!isModalDisplayed || !mode || !from || !to) return <></>

  const itineraryShareUrl = generateDomainFullRoute(
    ROUTE_ITINERARY_COMPUTING_BY_MODE,
    { from, to, mode },
    { [PARAM_REDIRECT]: REDIRECT_QRCODE }
  )
  if (d.enabled) {
    d('itineraryShareUrl:', itineraryShareUrl)
  }

  return (
    <Modal modalId={MODAL_IDS.SHARE_ITINERARY_POPIN}>
      <ClosePopinButton hasTag={false} onClose={onPopinClose} />
      <div className={s.root}>
        <div className={s.leftPart}>
          <div className={s.qrcodeWrapper}>
            <QRCodeSVG value={itineraryShareUrl} fgColor="#00346b" size="128" />
          </div>
          <ol className={s.instructions}>
            <li>
              <b>Scannez le QR Code</b> avec l&apos;appareil photo de votre téléphone
            </li>
            <li>
              <b>Cliquez</b> sur le lien
            </li>
            <li>
              <b>Retrouvez</b> votre itinéraire sur votre mobile
            </li>
          </ol>
        </div>
        <div className={s.rightPart}>
          <div className={s.title}>Emportez votre itinéraire dans votre poche !</div>
          <ul className={s.advantagesList}>
            <li className={s.advantagesItem}>
              <div className={s.advantagesIcon}>
                <SVGIcon url={mappyLogoOutline} width="32" height="32" />
              </div>
              <div>Un GPS efficace et gratuit</div>
            </li>
            <li className={s.advantagesItem}>
              <div className={s.advantagesIcon}>
                <SVGIcon url={signs} width="32" height="32" />
              </div>
              <div>Un itinéraire optimisé selon vos priorités : durée, prix, empreinte carbone</div>
            </li>
            <li className={s.advantagesItem}>
              <div className={s.advantagesIcon}>
                <SVGIcon url={france} width="32" height="32" />
              </div>
              <div>100% made in France qui respecte la vie privée</div>
            </li>
          </ul>
        </div>
      </div>
    </Modal>
  )
}

export default withOnlyGE(ShareItineraryPopin)
